import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=2cf47554&scoped=true&"
import script from "./bottomBar.vue?vue&type=script&lang=js&"
export * from "./bottomBar.vue?vue&type=script&lang=js&"
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=2cf47554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf47554",
  null
  
)

export default component.exports